import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, Stack } from '@mui/material';
// routes
import { PATH_PAGE } from '../../routes/paths';
// components
import Logo from '../../components/Logo';
import SocialsButton from '../../components/SocialsButton';
import { get } from 'lodash';
import { getCurrentYear } from 'src/utils/getCurrentYear';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'Get Started',
    children: [
      { name: 'Compare Plans', href: '/compare-plans' },
      { name: 'Enter Event', href: '/select-event' },
      { name: 'FAQ', href: '/faq' },
    ],
  },
  {
    headline: 'Quick Links',
    children: [
      { name: 'Schedule a meeting', href: 'https://calendly.com/arsh-events/meet', external: true },
      { name: 'Send us a message', href: '/contact' },
    ],
  },
  {
    headline: 'Contact',
    children: [
      { name: '(+234) 803 241 2212', href: '#' },
      { name: 'events@arsh.events', href: '#' },
      { name: '15B, Capt. Olajide George Street, Lekki, Lagos.', href: '#' },
    ],
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  const year = getCurrentYear();

  return (
    <RootStyle>
      <Divider />
      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
          </Grid>
          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              ARSH is Africa's pioneer, first-in-class comprehensive event management and immersive virtual exhibitions
              platform for events of every type and at every scale.
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              <SocialsButton sx={{ mx: 0.5 }} />
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => (
                <Stack key={list.headline} spacing={2}>
                  <Typography component="p" variant="overline">
                    {list.headline}
                  </Typography>
                  {list.children.map((link) =>
                    link?.external ? (
                      <Link
                        href={link.href}
                        target="_blank"
                        rel="noopener"
                        key={link.name}
                        color="inherit"
                        variant="body2"
                        sx={{ display: 'block' }}
                      >
                        {link.name}
                      </Link>
                    ) : (
                      <Link
                        to={link.href}
                        key={link.name}
                        color="inherit"
                        variant="body2"
                        component={RouterLink}
                        sx={{ display: 'block' }}
                      >
                        {link.name}
                      </Link>
                    )
                  )}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          © {year}. All rights reserved
        </Typography>
      </Container>
    </RootStyle>
  );
}
